export const mapEstimatedDateOfArrivalToApi = ({
  estimatedArrivalDate,
  billOfLading,
  pricingGroup,
  labelPurchaseType,
  id
}) => {
  const data = new FormData()
  if (labelPurchaseType.id === 1 && pricingGroup.id) {
    data.append('PricingGroupId', pricingGroup.id)
    data.append('PricingGroupName', pricingGroup.name)
    data.append('PricingGroupEstimatedShippingCost', pricingGroup.estimatedShippingCost)
    data.append('ShipbobZoneId', pricingGroup.shipbobZoneId)
    data.append('IsShipbobLabel', true)
  } else {
    const file = billOfLading.file
    data.append('EstimatedArrivalDate', estimatedArrivalDate)
    data.append('BillOfLadingFile', file)
    data.append('BillOfLadingName', file && file.name)
    data.append('IsShipbobLabel', false)
  }
  return {
    data,
    id
  }
}
